const memoryFields = {
    ValorNominal: "VN",
    ValorNominalAtualizado: "VNA",
    ValorJuros: "FinanceiroJuros",
    ValorIncorporacaoJuros: "IncorporacaoJuros",
    ValorAmortizacao: "FinanceiroAmortizacao",
    ValorAmortizacaoExtraordinaria: "FinanceiroAmortizacaoExtraordinaria",
    ValorPagamento: "Pagamento",
    CapitalizacaoJuros: "JurosCapitalizacao",
    ValorPremio: "Premio",
    TaxaLivreDeRisco: "TaxaRiskFree",
    ValorPresenteFluxo: "ValorMTMFluxo",
}

const mapMemory = (rows = []) => rows.map((row) => Object.entries(row)
    .filter(([field]) => field !== "LOGERRO")
    .reduce(
        (mapped, [field, value]) => ({...mapped, [memoryFields[field] ?? field]: value}),
        {},
    ))

const mapPremio = ({Aplicavel, Valor, MemoriaCalculo}) => ({
    aplicavel: Aplicavel,
    valor: Valor,
    memoria: mapMemory(MemoriaCalculo),
})

export const mapValidationCalculation = ({Parametros, PUPAR, PUMTM, Emissao, Indicadores, PremioRecompra, PremioConversibilidade, MemoriaCalculo}) => ({
    parameters: {
        dataReferencia: Parametros.DataReferencia,
        puparReferencia: Parametros.PUPARReferencia,
        pumtmReferencia: Parametros.PUMTMReferencia,
        spreadCredito: Parametros.SpreadCredito,
    },
    results: {
        puparCalculado: PUPAR.ValorCalculado,
        deltaPupar: PUPAR.DiferencaReferencia,
        variacaoPercentualPupar: PUPAR.VariacaoPercentual,
        pumtmCalculado: PUMTM.ValorCalculado,
        deltaPumtm: PUMTM.DiferencaReferencia,
        variacaoPercentualPumtm: PUMTM.VariacaoPercentual,
        spreadEmissao: Emissao.SpreadEmissao,
        prazoMedioEmissao: Emissao.PrazoMedioEmissao,
        percentualPupar: Indicadores.PercentualPUPAR,
        durationMacaulay: Indicadores.DurationMacaulay,
        durationModificada: Indicadores.DurationModificada,
    },
    premios: {
        recompra: mapPremio(PremioRecompra),
        conversibilidade: mapPremio(PremioConversibilidade),
    },
    memories: {
        pupar: mapMemory(MemoriaCalculo.PUPAR),
        pumtm: mapMemory(MemoriaCalculo.PUMTM),
        fatorCorrecao: mapMemory(MemoriaCalculo.FatorCorrecao),
    },
})
